import { apiClient } from '@src/services/http-common'
import { Metro2Reporting } from '@src/types/loan/loan-calendar'
import { useMutation } from '@tanstack/react-query'
import { Metro2ReportingDto } from './loan-dto'
import { transformMetro2ReportingFromDto } from './loan-transformer'

async function postMetro2Reporting(
  metro2ReportingDto: Metro2ReportingDto,
  loanId: string,
  financingProgramId: string,
): Promise<Metro2Reporting[]> {
  const response = await apiClient.post<Metro2ReportingDto[]>(
    `Loans/${financingProgramId}/${loanId}/Metro2Reporting`,
    metro2ReportingDto,
  )
  return (response.data ?? []).map(transformMetro2ReportingFromDto)
}

async function deleteMetro2Reporting(loanId: string, financingProgramId: string): Promise<void> {
  await apiClient.delete(`Loans/${financingProgramId}/${loanId}/Metro2Reporting`)
}

export function usePostMetro2Reporting(id: string, financingProgramId: string) {
  return useMutation({
    mutationFn: (metro2ReportingDto: Metro2ReportingDto) =>
      postMetro2Reporting(metro2ReportingDto, id, financingProgramId),
  })
}

export function useDeleteMetro2Reporting(id: string, financingProgramId: string) {
  return useMutation({
    mutationFn: () => deleteMetro2Reporting(id, financingProgramId),
  })
}
